<template>
  <svg
    :viewBox="isFlush ? FLUSH_VIEW_BOX : '0 0 24 24'"
    width="16"
    height="16"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
</template>

<script setup>
// isFlush: the box cropped to the ink (the strokes included), so the icon is as tall as the
// LinkedIn mark beside it (which fills its 24 × 24 box); otherwise ~1 unit is empty on each side
defineProps({isFlush: {type: Boolean, default: false}});
const FLUSH_VIEW_BOX = "1.06 1.06 21.88 21.88";
</script>
